import { API_BASE_URL, STORAGE_KEYS } from '../constants';

export function isRealtimeClientEnabled(): boolean {
  return String(process.env.REACT_APP_REALTIME_ENABLED || '').toLowerCase() === 'true';
}

export function isRealtimeSecureAuthEnabled(): boolean {
  return (
    isRealtimeClientEnabled() &&
    String(process.env.REACT_APP_REALTIME_SECURE_AUTH || 'true').toLowerCase() === 'true'
  );
}

export function getAccessToken(): string | null {
  try {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    return token && token !== 'undefined' && token !== 'null' ? token : null;
  } catch {
    return null;
  }
}

export function buildRealtimeWsUrl(): string {
  const httpBase = API_BASE_URL.replace(/\/api\/?$/, '');
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = httpBase.replace(/^https?:\/\//, '');
  if (isRealtimeSecureAuthEnabled()) {
    return `${wsProtocol}//${host}/ws/realtime`;
  }
  const token = getAccessToken();
  if (!token) return `${wsProtocol}//${host}/ws/realtime`;
  return `${wsProtocol}//${host}/ws/realtime?token=${encodeURIComponent(token)}`;
}

export const REALTIME_POLL_FALLBACK_MS = Number(process.env.REACT_APP_REALTIME_POLL_MS || 30000);
export const REALTIME_RECONNECT_BASE_MS = Number(process.env.REACT_APP_REALTIME_RECONNECT_MS || 3000);
export const REALTIME_PROJECTION_DEDUP_TTL_MS = 60_000;
